import { ProductPageLayout } from '../components/ProductPageLayout';

export function AiInfluencerBuilderPage() {
    return <ProductPageLayout productId="ai-influencer-builder" />;
}
